export default {
  getEventList: (_state: any) => _state.eventHistory,
  getFilterList: (_state: any) => _state.eventHistoryFilters,
  getEventHistoryParams: (_state: any) => _state.eventHistoryParams,
  getPagination: (_state: any) => _state.pagination,
  getRange: (_state: any) => _state.range,
}
